import UrlTypes from '@/enums/UrlTypes';

/**
 * ERS provider URL classification.
 */
export function classifyErsUrl(loc: string): UrlTypes {
    const normalizedLoc = loc.toLowerCase().trim();

    // Cart, ordering and root => OTHER
    if (
        normalizedLoc.includes('/cart') ||
        normalizedLoc.includes('/order-by-date') ||
        normalizedLoc === '/'
    ) {
        return UrlTypes.OTHER;
    }

    // Category hub vs category vs product vs page
    if (normalizedLoc.endsWith('/category/')) {
        return UrlTypes.CATEGORY_HUB;
    }
    if (normalizedLoc.includes('/category/')) {
        return UrlTypes.CATEGORY;
    }
    if (normalizedLoc.includes('/items/')) {
        return UrlTypes.PRODUCT;
    }
    if (normalizedLoc.includes('pages/')) {
        return UrlTypes.PAGE;
    }

    // Fallback
    return UrlTypes.PAGE;
}
